import { useMemo } from 'react';
import { useUser } from './UserContext';
import StudentPermissions from '../permissions/StudentPermissions';

export default function usePermissions() {
  const { user } = useUser();
  return useMemo(() => new StudentPermissions(user.role), [user.role]);
}
